<h2 mat-dialog-title> {{'COMMON.changes-have-been-saved'|translate}}</h2>
<mat-dialog-actions class="ti-changes-have-been-saved__actions">
  <button mat-mini-fab color="accent" mat-dialog-close>
    <mat-icon aria-hidden="true">done</mat-icon>
  </button>
</mat-dialog-actions>
